import React, { Component } from 'react';

export class AppFooter extends Component {

    render() {
        return  (
            <div className="layout-footer">
                <span className="footer-text" style={{'marginRight': '5px'}}>Team 4 Care &copy; 2020 - 2021</span>
            </div>
        );
    }
}